import { defaultSchema, Schema } from 'hast-util-sanitize';

// Extends the default (GitHub-style) sanitize schema so that raw HTML pasted into
// Qeta posts is cleaned instead of dropped, while still allowing:
// - `className` on `<code>`, which MarkdownRenderer needs to detect the syntax-highlight
//   language (`language-xxx`) — without this, sanitize would silently break all code blocks.
// - `className="mermaid"` on `<div>`, the marker rehypeMermaidBlocks uses to hand a block
//   off to the client-side mermaid renderer.
export const qetaSanitizeSchema: Schema = {
  ...defaultSchema,
  attributes: {
    ...defaultSchema.attributes,
    code: [...(defaultSchema.attributes?.code ?? []), 'className'],
    div: [...(defaultSchema.attributes?.div ?? []), ['className', 'mermaid']],
  },
};
